import React from 'react';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/salesData';
interface TestimonialCardProps {
  testimonial: Testimonial;
  showLocation?: boolean;
}
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-202" data-mp="2kfx3hve7gkj5">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-[var(--gold)] text-[var(--gold)]" aria-hidden="true" data-id="element-203" data-mp="2p99gf89iv2w2" data-mpi={i} />)}
    </div>;
}
export function TestimonialCard({
  testimonial,
  showLocation = true
}: TestimonialCardProps) {
  return <figure className="flex h-full flex-col rounded-2xl border border-[var(--olive)]/40 bg-[#0d0f08] p-6 transition-colors hover:border-[var(--gold)]/50" data-id="element-204" data-mp="3460ijpakyspd">
      <div className="mb-4 flex items-center gap-3" data-id="element-205" data-mp="3847w6b9qzdwc">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--olive)] text-sm font-bold text-[var(--cream)]" aria-hidden="true" data-id="element-206" data-mp="19s9auvbtaiwk">
          {testimonial.initials}
        </span>
        <div data-id="element-207" data-mp="hunmtsk487hs">
          <figcaption className="font-semibold text-[var(--cream)]" data-id="element-208" data-mp="d2e2qt5om1nf">
            {testimonial.name}
            {showLocation && <span className="font-normal text-white/50" data-id="element-209" data-mp="842qycvtth2k">
                {' '}
                · {testimonial.location}
              </span>}
          </figcaption>
          <Stars data-id="element-210" data-mp="10s8cv2ym9c3z" />
        </div>
      </div>
      <blockquote className="text-white/75" data-id="element-211" data-mp="10qxbtawk2igk">
        “{testimonial.quote}”
      </blockquote>
    </figure>;
}